<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="true"
            :bigTotal="bigTotal"
            :loading="loading" :total="total"
            helper="5nd2xV7Enm8qQe0o6aOkoA"
            :label="'Origine'">
      <div class="column is-paddingless is-border-left" slot="right-content">
        <router-link :to="{name: 'OriginCreate'}" class="page-header-btn is-small">
          <span class="icon"><i class="fas fa-plus-square"></i></span>
          <span>Nouvelle Origine</span>
        </router-link>
      </div>
      <div class="column is-paddingless is-border-left" slot="right-content">
        <a @click="loadItems()" class="page-header-btn is-small is-square">
          <span class="icon"><i class="fas fa-sync"></i></span>
        </a>
      </div>
    </sticky>
    <div class="columns is-padding-left-on-btn-actions is-padding-right-on-btn-actions is-padding-top">
      <div class="column is-12 is-paddingless">
        <div class="is-border is-radius-large">
          <div class="is-border-top">
            <table v-show="!loading && items.length" class="table is-fullwidth is-marginless-bottom is-last-fixed-small has-actionsontd">
              <thead>
              <tr class="is-size-6">
                <th>
                  <sortable @sort="sort('name', $event)" :sort="sortBy.name" label="Nom"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('multidiffusion', $event)" :sort="sortBy.multidiffusion" label="Multidiffusion"></sortable>
                </th>
                <th class="has-text-centered" width="70px">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(origin, index) in items" :key="origin.pk" class="is-size-6" :id="'e' + origin.pk" :class="{'has-status-bar--left has-status-bar--draft':scrollToEl === origin.pk}">
                <router-link :to="{name: 'OriginVue', params: {id: origin.pk}, query: {returnId: origin.pk}}" tag="td" class="is-cell-hoverable">
                  <a class="fullLink">{{origin.name}}</a>
                </router-link>
                <td><span v-if="origin.multidiffusion">Oui</span><span v-else>Non</span></td>
                <td class="has-text-centered actions">
                  <display-button-list :buttons="buttonList" :data="origin"
                    :openUp="{'position': index, 'total': items.length}">
                  </display-button-list>
                </td>
              </tr>
              <tr v-if="items.length < 3" class="empty"><td></td></tr>
              </tbody>
            </table>
            <div class="is-border-top" v-if="totalPage > 1 && nextPage">
              <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
                <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
                <span class="is-size-6">Afficher la suite</span>
              </a>
              <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
            </div>
            <div v-show="!loading && !items.length">
              <div class="columns">
                <div class="column">
                  <h2 class="title is-3 has-text-weight-bold">Aucune origine</h2>
                  <a class="has-text-primary" @click="resetFilters" v-if="hasFilter">
                    <span class="icon is-small"><i class="fal fa-undo-alt"></i></span>
                    <span>Réinitialiser les filtres</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GenericList, Sort, Filter } from '../../mixins'
  import { mapState } from 'vuex'

  export default {
    name: 'OriginList',
    mixins: [GenericList, Sort, Filter],
    props: {},
    data () {
      return {
        query: {
          has_parent: 0
        },
        loadDocuments: this.loadItems,
        buttonList: [
          {
            routeName: 'OriginEdit',
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'OriginEdit', params: {id: actionId}, query: {returnId: actionId}})
            },
            icon: 'fa-edit',
            text: 'Editer',
            needProfile: ['admin']
          },
          {
            action: (id, data) => {
              if (data.protected) {
                this.$notify({
                  type: 'is-danger',
                  text: 'Cette origine est liée à vos Multidiffusions et/ou Sites Publics, suppression impossible.'
                })
              } else {
                this.deleteItem(id)
              }
            },
            icon: 'fa-trash',
            text: 'Supprimer',
            needProfile: ['admin']
          }
        ],
        service: this.$api.originService,
        infiniteLoaderEnabled: true
      }
    },
    computed: {
      ...mapState(['scrollToEl'])
    },
    methods: {
      afterSuccessDelete (r) {
        this.loadItems()
      },
      successGet (r) {
        this.loading = false
        this.items = r.data
        this.totalPage = 1
        this.currentPage = 1
        this.total = this.items.length
        this.bigTotal = this.items.length
        this.successScroll()
        this.afterSuccessGet(r)
      }
    },
    created () {
      this.query.sort = 'name:asc'
      this.query.has_parent = 0
      this.loadItems()
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/origin/OriginList.vue